import Cookies from 'js-cookie';
import { get } from 'lodash';

import { setStaffToken } from '../../api/auth';
import clearLegacySsoCookies from '../../util/clearLegacySsoCookies';
import clearLocalStorage from '../../util/clearLocalStorage';
import { AUTHENTICATION_STATUS, ROLE_PORTAL_USER, ROLE_STAFF } from '../../util/constants';
import * as actionTypes from '../actionTypes';

export const saveCredentials = (params) => (dispatch) => {
  const { onSuccess = () => {}, staffToken, credentials } = params || {};
  const payload = {};
  payload.authenticationStatus = AUTHENTICATION_STATUS.AUTHENTICATED;
  payload.credentials = credentials;

  if (staffToken) {
    payload.role = ROLE_STAFF;
    payload.staffToken = staffToken;
    setStaffToken(staffToken);
  } else {
    payload.role = ROLE_PORTAL_USER;
    payload.staffToken = null;
    setStaffToken(null);
  }

  dispatch({
    type: actionTypes.HUB_AUTH_USER_AUTHENTICATED,
    payload,
  });

  onSuccess();
};

export const handleGetCredentialsFailed = (e) => (dispatch) => {
  const errorMsg = get(e, 'message', e);

  setStaffToken(null);
  // Clear Cognito/local session immediately. Leaving tokens in storage after
  // AUTHENTICATION_ERROR lets LoginPage's Auth.currentAuthenticatedUser() push
  // back to /home while ProtectedRoute redirects to /login (redirect loop).
  clearLocalStorage();
  clearLegacySsoCookies();
  Cookies.remove('staffToken');
  Cookies.remove('staffToken', { path: '/' });

  dispatch({
    type: actionTypes.HUB_AUTH_USER_AUTHENTICATION_ERROR,
    payload: {
      authenticationStatus: AUTHENTICATION_STATUS.AUTHENTICATION_ERROR,
      errorMsg,
    },
  });
};

export const handleClockSkewDetected = () => (dispatch) => {
  dispatch({ type: actionTypes.HUB_GLOBAL_CLOCK_SKEW_DETECTED });
};
